import { MutationTree } from 'vuex';
import { DocumentResource, DocumentState } from './types';
import { SingleFilter } from '@/store/types';

export const mutations: MutationTree<DocumentState> = {
    /** Documents */

    /**
     * Add an document to the list.
     *
     * @param state
     * @param document
     */
    addDocument(state, document: DocumentResource) {
        state.documents.push(document);
    },

    /**
     * Remove an document from the list.
     *
     * @param state
     * @param documentId
     */
    removeDocument(state, documentId: number) {
        state.documents = state.documents.filter((document) => document.id !== documentId);
    },

    /**
     * Set the documents list.
     *
     * @param state
     * @param documents
     */
    setDocuments(state, documents: DocumentResource[]) {
        state.documents = documents;
    },

    /**
     * Reset documents
     *
     * @param state
     */
    resetDocuments(state) {
        state.documents = [];
    },

    /**
     * Update an document.
     *
     * @param state
     * @param document
     */
    updateDocument(state, document: DocumentResource) {
        const index = state.documents.findIndex((item) => item.id === document.id);
        state.documents.splice(index, 1, document);
    },

    /** Filters */

    /**
     * Set a query filter in state.
     *
     * @param state
     * @param key
     * @param value
     */
    setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },

    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
